// import FontFaceObserver from 'fontfaceobserver';

// TODO

export default function fontsLoaded() {
  if (document.fonts && document.fonts.ready) {
    return Promise.race([
      document.fonts.ready,
      ...Array.from(document.fonts).map(font => font.loaded),
    ]);
  }

  return Promise.resolve();

  // return Promise.all([
  //   new FontFaceObserver('TCCC Unity Headline', { weight: 400 }),
  //   new FontFaceObserver('TCCC Unity Text', { weight: 400 }),
  // ]);
}



// WEBPACK FOOTER //
// ./src/scripts/modules/fontsLoaded.js